import React from 'react';
import woodlawnPoster from '../assets/woodlawn-poster.jpg'; // Import the Woodlawn poster
import CinemaSlideshow from './CinemaSlideshow';

const MovieInfoPage = ({ onBookSeats }) => {
  return (
    <div className="movie-info-page">
      <div className="cinema-header-bar">
        <div className="cinema-logo">🎬 RẠP PHIM SLC</div>
        <button className="cinema-book-btn btn btn-primary btn-lg" onClick={onBookSeats}>
          Đặt vé
        </button>
      </div>

      <div className="movie-info-container">
        <div className="movie-info-card">
          <div className="movie-poster-container">
            <img src={woodlawnPoster} alt="Woodlawn Movie Poster" />
          </div>

          <div className="movie-info-content">
            <h1 className="movie-title">Woodlawn</h1>

            <div className="event-meta">
              <div className="meta-item">
                <span className="meta-text">Thứ Sáu, 7 Tháng 11, 2025</span>
              </div>
              <div className="meta-item">
                <span className="meta-icon">🕖</span>
                <span className="meta-text">19:00 (Mở cửa 18:45)</span>
              </div>
              <div className="meta-item">
                <span className="meta-icon">📍</span>
                <span className="meta-text">
                  <a 
                    href="https://maps.app.goo.gl/3aey8zn6RgKD7xx6A" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="location-link"
                  >
                    36 Đ. Số 2, An Phú, Thủ Đức, Thành phố Hồ Chí Minh
                  </a>
                </span>
              </div>
            </div>

            <div className="section-divider"></div>

            <div className="about-section">
              <h3>Về bộ phim</h3>
              <p>
                Woodlawn là một câu chuyện có thật đầy cảm động về tinh thần thể thao, đức tin và sự đoàn kết. 
                Dựa trên câu chuyện có thật của đội bóng bầu dục trường Woodlawn High School, bộ phim kể về cách một huấn luyện viên và một mục sư đã thay đổi cuộc sống của những cầu thủ trẻ. 
                Thông qua tình yêu thương và đức tin, họ đã vượt qua những thử thách và tạo nên một đội bóng đoàn kết.
              </p>
            </div>

            <div className="hosted-section">
              <p><strong>Đơn vị tổ chức:</strong> SLC</p>
              <p>Mời bạn đến xem phim, ăn nhẹ và giao lưu – tất cả đều được chào đón!</p>
            </div>
          </div>
        </div>

        <div className="cinema-image-section">
          <h3>Rạp chiếu phim</h3>
          <CinemaSlideshow />
        </div>

        <div className="trailer-section">
          <h3>Xem trailer</h3>
          <div className="trailer-embed-responsive">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/BRQaEJv9qIk"
              title="Woodlawn Trailer"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>


      </div>
    </div>
  );
};

export default MovieInfoPage;
